export const PovezaveMobilniPaketi = {
  BASE_URL_MOBILNI_PAKET_MAXI: 'https://www.t-2.net/oranzni-maxi',
  BASE_URL_MOBILNI_PAKET_MIDI: 'https://www.t-2.net/oranzni-midi',
  BASE_URL_MOBILNI_PAKET_MINI: 'https://www.t-2.net/oranzni-mini',
  BASE_URL_MOBILNI_PAKET_TOP: 'https://www.t-2.net/mobilni-top'
}



// WEBPACK FOOTER //
// ./src/assets/js/PovezaveMobilniPaketi/PovezaveMobilniPaketi.js